<template>
  <transition name="slideUp">
    <div id="range" v-if="active">
      <div class="range__header">
        <div class="range__header-content">
          <div class="header__title">
            <svg class="icon icon-pin" aria-hidden="true" role="img">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-pin"></use>
            </svg>
            Calcul de distance
          </div>
          <span class="distance">{{ formatDistance() }}</span>
        </div>
        <ul class="group-buttons">
          <li>
            <button @click="expandRange">
              <svg v-if="expand" class="icon icon-reduce" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-reduce"></use>
              </svg>
              <svg v-else class="icon icon-expand" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-expand"></use>
              </svg>
            </button>
          </li>
          <li>
            <button @click="closeRange">
              <svg class="icon icon-close" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close"></use>
              </svg>
            </button>
          </li>
        </ul>
      </div>
      <div class="range__content" v-show="expand">
        Cliquer sur la carte pour ajouter un point
        <ul>
          <li>
            <button @click="deleteLastMarker">
              <svg class="icon icon-back" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-back"></use>
              </svg>
              Retirer le dernier point
            </button>
          </li>
          <li>
            <button @click="deleteAllMarkers">
              <svg class="icon icon-close" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close"></use>
              </svg>
              Retirer tous les points
            </button>
          </li>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
  /* global L */
  /* global cgy_vars */
  /* eslint no-undef: "error" */
  import store from '../store/store'
  // import json from '../store/jsonUrl'

  export default {
    name: 'range',
    data () {
      return {
        active: false,
        expand: false,
        range: 0,
        iconUrl: cgy_vars.defaultMarker,
        markers: [],
        polylines: [],
        strokeColor: cgy_vars.line.strokeColor
      }
    },
    methods: {
      rangeOnClick: function () {
        this.active = true
        this.expand = true
        this.addMarkerOnMapClick()
      },
      addMarkerOnMapClick: function () {
        let that = this
        if (this.active) {
          store.state.map.on('click', function (e) {
            let markerIcon = L.icon({
              iconUrl: that.iconUrl,
              iconSize: [21, 26],
              iconAnchor: [10.5, 26]
            })
            let marker = L.marker(e.latlng, {icon: markerIcon})
            store.state.map.addLayer(marker)
            that.markers.push(marker)
            that.drawLineBetweenMarkers()
            that.distanceBetweenMarkers()
          })
        }
      },
      drawLineBetweenMarkers: function () {
        if (this.markers.length < 2) {
          return
        }
        let latlngs = []
        let index = this.markers.length - 1
        let last = this.markers[index]
        latlngs.push(last.getLatLng())
        let prev = this.markers[index - 1]
        latlngs.push(prev.getLatLng())
        let polyline = L.polyline(latlngs, {color: this.strokeColor})
        store.state.map.addLayer(polyline)
        this.polylines.push(polyline)
      },
      distanceBetweenMarkers: function () {
        let that = this
        this.range = 0
        if (this.markers.length > 1) {
          this.markers.forEach(function (marker, i) {
            if (i > 0) {
              let distance = marker.getLatLng().distanceTo(that.markers[i - 1].getLatLng())
              that.range = +(that.range + distance).toFixed()
            }
          })
        }
      },
      formatDistance: function () {
        if (this.range < 1000) {
          return `${this.range} m`
        } else {
          let rangeKm = +(this.range / 1000).toFixed(2)
          return `${rangeKm} km`
        }
      },
      deleteLastMarker: function () {
        if (this.markers.length > 0) {
          store.state.map.removeLayer(this.markers[this.markers.length - 1])
          this.markers.pop()
        }
        if (this.polylines.length > 0) {
          store.state.map.removeLayer(this.polylines[this.polylines.length - 1])
          this.polylines.pop()
        }
        this.distanceBetweenMarkers()
      },
      deleteAllMarkers: function () {
        this.markers.forEach(function (marker) {
          store.state.map.removeLayer(marker)
        })
        this.polylines.forEach(function (polyline) {
          store.state.map.removeLayer(polyline)
        })
        this.markers = []
        this.polylines = []
        this.range = 0
      },
      closeRange: function () {
        // close proximity panel
        this.active = false
        this.expand = false
        this.deleteAllMarkers()
        store.state.map.off('click')
      },
      expandRange: function () {
        this.expand = !this.expand
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Range.vue?e2898c86